import { memo, ReactNode } from "react";

import { HelpCircle } from "@hl/base-components/lib/assets/icons.generated/index";
import {
  FEATURE_FLAGS,
  useFeatureFlags,
} from "@hl/shared-features/lib/features/auth/hooks/useFeatureFlags";
import {
  Anchor,
  Center,
  Container,
  Group,
  Space,
  Text,
  Title,
} from "@mantine/core";

import { _CollectionType } from "apollo/graphql.generated";
import { EXTERNAL_URL } from "config";
import SelectCollectionCards from "~/features/collections/forms/CreateCollectionMultistepForm/SelectCollectionCards";
import { createFormDraft } from "~/features/collections/forms/CreateCollectionMultistepForm/index";

import {
  useCreateCollectionFormContext,
  useCreateCollectionState,
} from "./context";

export type _CollectionTypeOptionProps = {
  label: string;
  description: string;
  onClick: () => void;
  leftIcon?: ReactNode;
};

//TODO: Completely reset form reaching this step
const SelectTokenType = () => {
  const enableGenSeries = useFeatureFlags(FEATURE_FLAGS.ENABLE_JOBS_GEN_SERIES);

  const { dispatch } = useCreateCollectionState();
  const form = useCreateCollectionFormContext();

  const createDraft = (collectionType: _CollectionType) => {
    createFormDraft(collectionType, form);

    dispatch({
      type: "NEXT_STEP",
      payload: {
        collectionType,
        form,
      },
    });
  };

  const collectionTypes = [
    _CollectionType.OpenEdition,
    enableGenSeries ? _CollectionType.GenerativeSeries : null,
    _CollectionType.Series,
  ]
    .filter((v) => v != null)
    .map((collectionType) => ({
      type: collectionType!,
      onClick: () => createDraft(collectionType!),
    }));

  return (
    <Container>
      <SelectCollectionCards
        title={
          <Title ta="center" order={3} fw={500}>
            What type of collection do
            <br />
            you want to create?
          </Title>
        }
        handlers={collectionTypes.map((collectionType) => ({
          type: collectionType.type,
          handler: {
            type: "button",
            onClick: collectionType.onClick,
          },
        }))}
        withBorder
      />
      <Space h={32} />
      <Center>
        <Anchor
          underline={false}
          href={EXTERNAL_URL.SUPPORT_ARTWORK_GLOSSARY}
          target="_blank"
          rel="noreferrer"
          style={{ textDecoration: "none" }}
        >
          <Group spacing={7} pb="xs">
            <HelpCircle width={17} height={17} cursor={"pointer"} />
            <Text variant="text" size="sm" weight={500}>
              {" "}
              Learn more about artwork types
            </Text>
          </Group>
        </Anchor>
      </Center>
    </Container>
  );
};

export default memo(SelectTokenType);
